<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="_width" :height="_height" :spin="spin" :rtl="rtl" viewBox="0 0 1024 1024" preserveAspectRatio="xMidYMid meet" fill="" role="presentation" ref="host">
    <g>
      <path d="M803.5 72c0 16.8-.4 35.7-1.4 56.6-1 21.6-2.2 43.2-3.5 64.8-1.4 22.2-2.8 44.1-4.2 65.4-1.4 21.5-3.5 41-6.4 58.5h-37l-73.9-179.8H545.4V952h-340v-36.4c20.6-6.7 41.5-12.5 62.6-17.6 21.1-5.1 43.9-9.2 68.2-12.6V137.5h-134l-74.5 179.8H92.6c-2.8-16.8-5.1-35.9-7-57.2-1.9-21.3-3.6-43.1-5-65.4-1.5-22.1-2.6-44-3.8-65.4-1-21.2-1.4-40.4-1.4-57.2h728.1zm122 880h-300c-16 0-29-13-29-29s13-29 29-29h300c16 0 29 13 29 29s-13 29-29 29z" data-follow-fill="currentColor" :fill="_fill" />
      <path d="M925.5 782h-300c-16 0-29-13-29-29s13-29 29-29h300c16 0 29 13 29 29s-13 29-29 29z" data-follow-fill="currentColor" :fill="_fill" />
    </g>
  </svg>
</template>
<script setup>
import { ref, computed, onMounted, onUpdated } from 'vue';
const props = defineProps({
  width: {
    type: [Number, String],
    required: false
  },
  height: {
    type: [Number, String],
    required: false
  },
  stroke: {
    type: String,
    required: false
  },
  fill: {
    type: String,
    required: false
  },
  color: {
    type: String,
    required: false
  },
  spin: {
    type: Boolean,
    required: false
  },
  rtl: {
    type: Boolean,
    required: false
  }
});
const size = '1em';

const _fill = computed(() => props.fill || props.color || undefined);
const _stroke = computed(() => props.stroke || props.color || undefined);
const _width = computed(() => props.width || size || undefined);
const _height = computed(() => props.height || size || undefined);
const host = ref(null);

onMounted(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
onUpdated(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
</script>

<style scoped>
svg[spin='true'] {
  animation: iconpark-spin 1s infinite linear;
}

svg[spin='true'][rtl='true'] {
  animation: iconpark-spin-rtl 1s infinite linear;
}

svg[rtl='true'] {
  transform: scaleX(-1);
}
@keyframes iconpark-spin {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes iconpark-spin-rtl {
  0% {
    -webkit-transform: scaleX(-1) rotate(0);
    transform: scaleX(-1) rotate(0);
  }

  100% {
    -webkit-transform: scaleX(-1) rotate(360deg);
    transform: scaleX(-1) rotate(360deg);
  }
}
</style>
